import { Flex, Text } from "@chakra-ui/react";
import React, { useCallback, useState } from "react";
import {
  HiOutlineThumbDown,
  HiOutlineThumbUp,
  HiThumbDown,
  HiThumbUp,
} from "react-icons/hi";

import { IconButton } from "../../../../components";
import {
  SegmentAnalytics,
  useSendGAEvent,
} from "../../../../utils/googleAnalytics";

type InsightsFeedbackProps = {
  messageId: string;
};

type FeedbackValence = "positive" | "negative";

export function InsightsFeedback({
  messageId,
}: InsightsFeedbackProps): React.ReactElement {
  const [submitted, setSubmitted] = useState<FeedbackValence | null>(null);
  const sendGAEvent = useSendGAEvent();

  const submitFeedback = useCallback(
    (valence: FeedbackValence): void => {
      if (submitted === valence) return;
      sendGAEvent(
        "rate_ai_custom_insights",
        "user_feedback",
        "Feedback",
        valence,
        { messageId }
      );
      SegmentAnalytics.track("custom_insights_feedback", {
        valence,
        messageId,
      });
      setSubmitted(valence);
    },
    [messageId, sendGAEvent, submitted]
  );

  return (
    <Flex flex={1} minW={0} align="center" justify="center" gap="4px">
      <Text fontSize="sm" color="gray.600" whiteSpace="nowrap">
        How were the results?
      </Text>
      <IconButton
        aria-label="Thumbs up"
        variant="unstyled"
        size="sm"
        color="purple.600"
        shouldSendGAEvent={false}
        icon={
          submitted === "positive" ? (
            <HiThumbUp
              size="20px"
              data-testid="insights-feedback-thumb-up-filled"
            />
          ) : (
            <HiOutlineThumbUp
              size="20px"
              data-testid="insights-feedback-thumb-up-outline"
            />
          )
        }
        onClick={() => submitFeedback("positive")}
      />
      <IconButton
        aria-label="Thumbs down"
        variant="unstyled"
        size="sm"
        color="purple.600"
        shouldSendGAEvent={false}
        icon={
          submitted === "negative" ? (
            <HiThumbDown
              size="20px"
              data-testid="insights-feedback-thumb-down-filled"
            />
          ) : (
            <HiOutlineThumbDown
              size="20px"
              data-testid="insights-feedback-thumb-down-outline"
            />
          )
        }
        onClick={() => submitFeedback("negative")}
      />
    </Flex>
  );
}
